var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('BaseTable',{attrs:{"items":_vm.items,"headers":_vm.headers,"title":"Überschreibung: Preis","componentName":"NgwOverwriteArticlePrice","loading":_vm.loading,"editMutation":'updateOverwriteArticlePrice',"deleteMutation":'deleteOverwriteArticlePrice',"isApprovedButton":""},on:{"refresh":_vm.updateList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }